// Os lembretes que a pessoa resolveu FORA do cartão do aviso na tela (passo 18, PR 2, achado 7 do E2E): concluiu, adiou,
// remarcou ou cancelou pela bolha, pelo painel, por outra aba ou pelo botão do push. O cartão fica aberto até a pessoa
// agir (D3-a), então precisa saber que o lembrete dele já não espera ninguém — senão o [Concluir] devolve 409.
//
// Pequeno repositório de módulo, e não react-query nem prop: o `Toaster` mora FORA do `NotificationProvider` e o
// `CartaoDoLembrete` age só por `acoes` (os testes do aviso o montam sem `QueryClientProvider`). Quem alimenta é o
// `NotificationContext`, no ramo `lembrete:atualizado`; quem lê é o cartão, por `useSyncExternalStore`.
//
// ⚠️ O id sai daqui quando o lembrete TOCA DE NOVO (adiado, remarcado): senão o toque novo nasceria "já resolvido".
// O contexto limpa nos dois caminhos que o anunciam — o evento `lembrete:atualizado` com `tocou` e o `notification:new`
// do toque — porque os dois chegam em ordem qualquer.

/** Teto de ids guardados: o cartão só olha para os lembretes que ele está mostrando, e esses são poucos. */
const LIMITE = 500;

let ids: ReadonlySet<string> = new Set();
const ouvintes = new Set<() => void>();

function trocar(novo: Set<string>): void {
  ids = novo;
  ouvintes.forEach((o) => o());
}

/** O lembrete mudou de status fora do cartão (não está mais em `tocou`). */
export function lembreteResolvidoFora(id: string): void {
  if (ids.has(id)) return;
  const novo = new Set(ids);
  novo.add(id);
  // Passou do teto: sai o mais antigo (o `Set` guarda a ordem de entrada).
  if (novo.size > LIMITE) novo.delete(novo.values().next().value as string);
  trocar(novo);
}

/** O lembrete tocou de novo: volta a esperar a pessoa. */
export function lembreteVoltouATocar(id: string): void {
  if (!ids.has(id)) return;
  const novo = new Set(ids);
  novo.delete(id);
  trocar(novo);
}

/** Para o `useSyncExternalStore`: o `Set` só muda de identidade quando muda de conteúdo. */
export function resolvidosFora(): ReadonlySet<string> {
  return ids;
}

export function inscreverResolvidosFora(ouvinte: () => void): () => void {
  ouvintes.add(ouvinte);
  return () => {
    ouvintes.delete(ouvinte);
  };
}

/** Só para os testes. */
export function _reiniciarResolvidosForaParaTeste(): void {
  trocar(new Set());
}
